// extracted by mini-css-extract-plugin
export default {"card":"index_card__299tR typography_bodyFont__3RHTp","section":"index_section__nzYsq","heading":"index_heading__2-YQI"};